require('./dist/angular-local-storage.js');
module.exports = 'LocalStorageModule';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-local-storage/index.js
 ** module id = 5
 ** module chunks = 0
 **/